import React from 'react';
import { render, hydrate } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import {IntlProvider} from "react-intl";
import {language, messages} from "../locales/localesConfig";

import store from './store/store';
import history from './store/history';
import Routes from '../router/routes';

hydrate(  
  <Provider store={store}>
    <IntlProvider locale={language} messages={messages[language]} onError={(error) => {}}>
      <Router>        
        <Routes/>        
      </Router>
    </IntlProvider>
  </Provider>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./source/client/client.jsx